import AmexCenturionNYUpcomingEvents from './AmexCenturionNYUpcomingEvents';

export default AmexCenturionNYUpcomingEvents;
